import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardBody, Col, Alert } from 'reactstrap';
import LoginForm from './Form';
import AppLogo from './../../../assets/img/brand/logo.jpeg';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { authActionTypes } from '@store/Auth/Auth.actionTypes';
import InvitationDescription from '@/components/InvitationDescription';
import { useSelector } from 'react-redux';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import styles from './Login.module.scss';
const Login = ({ dispatch = () => {} }) => {
  const handleSubmit = (values) => {
    dispatch({
      type: authActionTypes.LOGIN,
      payload: values,
    });
  };

  const location = useLocation();
  const { i: invitationId } = queryString.parse(location.search);
  const invitationData = useSelector(
    (state) => state.invitation.invitationData
  );
  return (
    <>
      <Col lg="5" md="7" style={{ minWidth: 580 }}>
        <Card className="bg-white shadow border-0">
          <CardHeader className="bg-transparent pb-2 border-0">
            <div className="text-center">
              <img className="auth-app-logo" src={AppLogo} alt="workfromhome" />
            </div>
            <div className={styles.loginHeader}>
              <Text
                variant={textVariantsEnum.Text_25}
                fontWeight={fontWeightEnum.Semibold}
              >
                {' '}
                Welcome!
              </Text>
              <Text
                variant={textVariantsEnum.Text_15}
                fontWeight={fontWeightEnum.Semibold}
                style={{ color: '#343942' }}
              >
                Log into your account
              </Text>
            </div>

            {invitationId &&
              invitationId == invitationData?.invitationId &&
              invitationData?.userDetails?.registered && (
                <div className="mt-3">
                  <Alert color="primary">
                    <InvitationDescription
                      invitationData={invitationData}
                      variant="signin"
                    />
                  </Alert>
                </div>
              )}
          </CardHeader>
          <CardBody className="px-lg-7 py-lg-4">
            <LoginForm onSubmit={handleSubmit} />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

Login.propTypes = {
  dispatch: PropTypes.func,
};

export default Login;
